import { isCheckoutPurchasePath } from './checkoutOverlayNavigation';

export const CHECKOUT_AUTH_PATH = '/checkout/account';
export const CHECKOUT_AUTH_FALLBACK_PATH = '/pricing';

const getCurrentOrigin = (): string => (
  typeof window !== 'undefined' && window.location?.origin
    ? window.location.origin
    : 'https://botspot.trade'
);

export const normalizeCheckoutAuthReturnTo = (returnTo?: string | null): string => {
  if (!returnTo) {
    return CHECKOUT_AUTH_FALLBACK_PATH;
  }

  try {
    const currentOrigin = getCurrentOrigin();
    const parsed = new URL(returnTo, currentOrigin);
    if (parsed.origin !== currentOrigin || !isCheckoutPurchasePath(parsed.pathname)) {
      return CHECKOUT_AUTH_FALLBACK_PATH;
    }

    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return CHECKOUT_AUTH_FALLBACK_PATH;
  }
};

export const buildCheckoutAuthPath = (returnTo?: string | null): string => {
  const params = new URLSearchParams({
    returnTo: normalizeCheckoutAuthReturnTo(returnTo),
  });
  return `${CHECKOUT_AUTH_PATH}?${params.toString()}`;
};
